module.exports = __webpack_public_path__ + "img/bg3.06e70590.png";